<div class="theme-selector">
  <div class="ts-header mt-3">
    <div class="ts-title">
      <mat-icon>palette</mat-icon>
      <span>Theme Options</span>
    </div>
    <button mat-icon-button (click)="close()" aria-label="Close">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-tab-group animationDuration="200ms" class="ts-tabs"
                 [(selectedIndex)]="activeTabIndex"
                 (selectedTabChange)="onTabChange($event)">

    <!-- ─────────── COMBINED THEME + LAYOUT TEMPLATES TAB ─────────── -->
    <mat-tab label="Theme and Layout Templates">
      <div class="ts-tab-body">
        <p class="ts-hint">Pick a template, hit <b>Apply &amp; Preview</b> to try it across the app.</p>

        <p class="ts-section-header">Default Templates</p>
        <div class="ts-grid">
          <button
            type="button"
            *ngFor="let t of themes"
            class="ts-card"
            [class.selected]="selectedId === t.id"
            [class.active]="activeId === t.id"
            (click)="selectTemplate(t.id)">
            <div class="ts-swatches">
              <span class="sw" [style.background]="t.preview.primary"></span>
              <span class="sw" [style.background]="t.preview.surface"></span>
              <span class="sw" [style.background]="t.preview.accent"></span>
            </div>
            <div class="ts-card-name">{{ t.name }}</div>
            <div class="ts-card-type">{{ t.type }}</div>
            <span class="ts-active-pill" *ngIf="activeId === t.id">Active</span>
          </button>
        </div>

        <!-- ── User-created custom presets (Custom 1, Custom 2, …) ── -->
        <div *ngIf="customPresets.length > 0" class="ts-custom-presets">
          <p class="ts-section-header">Custom Templates</p>
          <div class="ts-grid">
            <div
              *ngFor="let p of customPresets"
              class="ts-card ts-card-with-delete"
              [class.selected]="selectedId === p.id"
              [class.active]="activeId === p.id">
              <button
                type="button"
                class="ts-card-body-btn"
                (click)="selectTemplate(p.id)">
                <div class="ts-swatches">
                  <span class="sw" [style.background]="presetSwatches(p)[0]"></span>
                  <span class="sw" [style.background]="presetSwatches(p)[1]"></span>
                  <span class="sw" [style.background]="presetSwatches(p)[2]"></span>
                </div>
                <div class="ts-card-name">{{ p.name }}</div>
                <div class="ts-card-type">CUSTOM</div>
              </button>
              <span class="ts-active-pill" *ngIf="activeId === p.id">Active</span>
              <!-- Top-right cross to remove this custom preset. stopPropagation
                   so clicking the X doesn't also select the card. -->
              <button
                type="button"
                class="ts-card-delete"
                aria-label="Delete custom template"
                (click)="deleteCustomPreset(p, $event)">
                <mat-icon>close</mat-icon>
              </button>
            </div>
          </div>

          <div *ngIf="selectedCustomPreset" class="ts-custom-actions">
            <button
              type="button"
              mat-stroked-button
              class="ts-edit-custom-btn"
              (click)="editCustomPreset(selectedCustomPreset!, $event)">
              <mat-icon>edit</mat-icon>
              <span>Edit</span>
            </button>
            <button
              type="button"
              mat-stroked-button
              class="ts-delete-custom-btn"
              (click)="deleteCustomPreset(selectedCustomPreset!, $event)">
              <mat-icon>delete</mat-icon>
              <span>Delete</span>
            </button>
          </div>
        </div>

        <!-- ── Layout Templates section (formerly its own tab) ── -->
        <p class="ts-section-header">Layout Templates</p>
        <p class="ts-hint">
          Pick a layout — your dashboard's existing widgets will reflow into the chosen row pattern.
        </p>
        <div class="ts-grid ts-layout-grid">
          <button
            type="button"
            *ngFor="let l of layouts"
            class="ts-card ts-layout-card"
            [class.selected]="selectedLayoutId === l.id"
            [class.active]="activeLayoutId === l.id"
            (click)="selectLayout(l.id)">
            <div class="ts-layout-preview">
              <div class="ts-layout-row" *ngFor="let count of l.rowCounts">
                <div class="ts-layout-cell" *ngFor="let _ of countToArray(count)"></div>
              </div>
            </div>
            <span class="ts-active-pill" *ngIf="activeLayoutId === l.id">Active</span>
          </button>
        </div>
      </div>
    </mat-tab>

    <!-- ─────────── TEMPLATES TAB (standalone, themes only) ─────────── -->
    <!-- <mat-tab label="Theme Templates">
      <div class="ts-tab-body">
        <p class="ts-hint">Pick a template, hit <b>Apply &amp; Preview</b> to try it across the app.</p>

        <p class="ts-section-header">Default Templates</p>
        <div class="ts-grid">
          <button
            type="button"
            *ngFor="let t of themes"
            class="ts-card"
            [class.selected]="selectedId === t.id"
            [class.active]="activeId === t.id"
            (click)="selectTemplate(t.id)">
            <div class="ts-swatches">
              <span class="sw" [style.background]="t.preview.primary"></span>
              <span class="sw" [style.background]="t.preview.surface"></span>
              <span class="sw" [style.background]="t.preview.accent"></span>
            </div>
            <div class="ts-card-name">{{ t.name }}</div>
            <div class="ts-card-type">{{ t.type }}</div>
            <span class="ts-active-pill" *ngIf="activeId === t.id">Active</span>
          </button>
        </div> -->

        <!-- ── User-created custom presets (Custom 1, Custom 2, …) ── -->
        <!-- <div *ngIf="customPresets.length > 0" class="ts-custom-presets">
          <p class="ts-section-header">Custom Templates</p>
          <div class="ts-grid">
            <div
              *ngFor="let p of customPresets"
              class="ts-card ts-card-with-delete"
              [class.selected]="selectedId === p.id"
              [class.active]="activeId === p.id">
              <button
                type="button"
                class="ts-card-body-btn"
                (click)="selectTemplate(p.id)">
                <div class="ts-swatches">
                  <span class="sw" [style.background]="presetSwatches(p)[0]"></span>
                  <span class="sw" [style.background]="presetSwatches(p)[1]"></span>
                  <span class="sw" [style.background]="presetSwatches(p)[2]"></span>
                </div>
                <div class="ts-card-name">{{ p.name }}</div>
                <div class="ts-card-type">CUSTOM</div>
              </button>
              <span class="ts-active-pill" *ngIf="activeId === p.id">Active</span>
              <button
                type="button"
                class="ts-card-delete"
                aria-label="Delete custom template"
                (click)="deleteCustomPreset(p, $event)">
                <mat-icon>close</mat-icon>
              </button>
            </div>
          </div>

          <div *ngIf="selectedCustomPreset" class="ts-custom-actions">
            <button
              type="button"
              mat-stroked-button
              class="ts-edit-custom-btn"
              (click)="editCustomPreset(selectedCustomPreset!, $event)">
              <mat-icon>edit</mat-icon>
              <span>Edit</span>
            </button>
            <button
              type="button"
              mat-stroked-button
              class="ts-delete-custom-btn"
              (click)="deleteCustomPreset(selectedCustomPreset!, $event)">
              <mat-icon>delete</mat-icon>
              <span>Delete</span>
            </button>
          </div>
        </div>
      </div>
    </mat-tab> -->

    <!-- ─────────── CUSTOM TAB ─────────── -->
    <mat-tab label="Custom Theme Builder">
      <div class="ts-tab-body">
        <p class="ts-section-header">{{ customSectionHeading }}</p>
        <p class="ts-hint">
          {{ editingPresetId
              ? 'Update the colors and styling for this custom template.'
              : 'Tweak any token below — Save adds this as a new custom template.' }}
        </p>

        <div class="ts-custom-row">
          <label>Side Nav color</label>
          <div class="ts-color-input">
            <input type="color" [(ngModel)]="custom.sidebarBg" />
            <input type="text" [(ngModel)]="custom.sidebarBg" class="ts-hex" />
          </div>
        </div>

        <div class="ts-custom-row">
          <label>Top Nav color</label>
          <div class="ts-color-input">
            <input type="color" [(ngModel)]="custom.toolbarBg" />
            <input type="text" [(ngModel)]="custom.toolbarBg" class="ts-hex" />
          </div>
        </div>

        <div class="ts-custom-row">
          <label>Dashboard background</label>
          <div class="ts-color-input">
            <input type="color" [(ngModel)]="custom.contentBg" />
            <input type="text" [(ngModel)]="custom.contentBg" class="ts-hex" />
          </div>
        </div>

        <div class="ts-custom-row">
          <label>Card header color</label>
          <div class="ts-color-input">
            <input type="color" [(ngModel)]="custom.cardHeaderBg" />
            <input type="text" [(ngModel)]="custom.cardHeaderBg" class="ts-hex" />
          </div>
        </div>

        <div class="ts-custom-row">
          <label>Text color</label>
          <div class="ts-color-input">
            <input type="color" [(ngModel)]="custom.contentText" />
            <input type="text" [(ngModel)]="custom.contentText" class="ts-hex" />
          </div>
        </div>

        <div class="ts-custom-row">
          <label>Background image</label>
          <div class="ts-bg-image">
            <div class="ts-bg-image-controls">
              <input
                type="file"
                accept="image/*"
                (change)="onBackgroundImageSelected($event)"
                #bgFileInput
                hidden />
              <button
                type="button"
                mat-stroked-button
                (click)="bgFileInput.click()"
                class="ts-bg-image-btn">
                <mat-icon>upload</mat-icon>
                <span>{{ custom.contentBgImageDataUrl ? 'Replace' : 'Upload image' }}</span>
              </button>
              <button
                *ngIf="custom.contentBgImageDataUrl"
                type="button"
                mat-stroked-button
                color="warn"
                (click)="removeBackgroundImage()"
                class="ts-bg-image-btn">
                <mat-icon>delete</mat-icon>
                <span>Remove</span>
              </button>
            </div>
            <div
              *ngIf="custom.contentBgImageDataUrl"
              class="ts-bg-image-preview"
              [style.background-image]="'url(' + custom.contentBgImageDataUrl + ')'">
            </div>
            <div *ngIf="bgImageWarning" class="ts-bg-image-warning">{{ bgImageWarning }}</div>
          </div>
        </div>

        <div class="ts-custom-row">
          <label>Font Family</label>
          <mat-form-field appearance="outline" class="ts-font-select">
            <mat-select [(ngModel)]="custom.fontFamily">
              <mat-option *ngFor="let f of fontChoices" [value]="f.stack">{{ f.label }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="ts-custom-row">
          <label>Card border radius</label>
          <mat-form-field appearance="outline" class="ts-font-select">
            <mat-select [(ngModel)]="custom.cardBorderRadius">
              <mat-option *ngFor="let r of radiusChoices" [value]="r.value">{{ r.label }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="ts-custom-row">
          <label>Card style</label>
          <mat-form-field appearance="outline" class="ts-font-select">
            <mat-select [(ngModel)]="custom.cardStyle">
              <mat-option *ngFor="let s of cardStyleChoices" [value]="s.value">{{ s.label }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="ts-custom-row">
          <label>Button shape</label>
          <mat-form-field appearance="outline" class="ts-font-select">
            <mat-select [(ngModel)]="custom.buttonShape">
              <mat-option *ngFor="let s of buttonShapeChoices" [value]="s.value">{{ s.label }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="ts-custom-row">
          <label>Button color</label>
          <div class="ts-color-input">
            <input type="color" [(ngModel)]="custom.buttonColor" />
            <input type="text" [(ngModel)]="custom.buttonColor" class="ts-hex" />
          </div>
        </div>

        <div class="ts-custom-row">
          <label>Widget spacing</label>
          <mat-form-field appearance="outline" class="ts-font-select">
            <mat-select [(ngModel)]="custom.widgetSpacing">
              <mat-option *ngFor="let s of widgetSpacingChoices" [value]="s.value">{{ s.label }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="ts-custom-row">
          <label>Card padding</label>
          <mat-form-field appearance="outline" class="ts-font-select">
            <mat-select [(ngModel)]="custom.cardPadding">
              <mat-option *ngFor="let s of cardPaddingChoices" [value]="s.value">{{ s.label }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="ts-custom-row">
          <label>Custom layout</label>
          <mat-form-field appearance="outline" class="ts-font-select">
            <mat-select [(ngModel)]="custom.layoutId">
              <!-- Empty value = "no pairing" — preset stays layout-agnostic
                   so the active layout isn't disturbed when the preset is
                   applied. See upsertEditingPreset for the '' → undefined
                   conversion. -->
              <mat-option [value]="''">No layout pairing</mat-option>
              <mat-option *ngFor="let l of layouts" [value]="l.id">{{ l.name }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    </mat-tab>

    <!-- ─────────── LAYOUT TEMPLATES TAB (standalone, layouts only) ─────────── -->
    <!-- <mat-tab label="Layout Templates">
      <div class="ts-tab-body">
        <p class="ts-hint">
          Pick a layout — your dashboard's existing widgets will reflow into the chosen row pattern.
        </p>
        <div class="ts-grid ts-layout-grid">
          <button
            type="button"
            *ngFor="let l of layouts"
            class="ts-card ts-layout-card"
            [class.selected]="selectedLayoutId === l.id"
            [class.active]="activeLayoutId === l.id"
            (click)="selectLayout(l.id)">
            <div class="ts-layout-preview">
              <div class="ts-layout-row" *ngFor="let count of l.rowCounts">
                <div class="ts-layout-cell" *ngFor="let _ of countToArray(count)"></div>
              </div>
            </div>
            <span class="ts-active-pill" *ngIf="activeLayoutId === l.id">Active</span>
          </button>
        </div>
      </div>
    </mat-tab> -->

    <!-- ─────────── SLIDESHOW TAB ─────────── -->
    <mat-tab label="Slideshow">
      <div class="ts-tab-body ts-slideshow">
        <p class="ts-hint">
          Hit <b>Play</b> to cycle through every theme. <b>Pause</b> when you find
          one you like, then <b>Save</b> to apply it permanently.
        </p>

        <ng-container *ngIf="slideshowItems.length > 0; else noSlides">
          <div class="ts-slide-stage">
            <div class="ts-slide-card">
              <div class="ts-slide-swatches">
                <span class="sw" [style.background]="currentSlide?.swatches?.[0]"></span>
                <span class="sw" [style.background]="currentSlide?.swatches?.[1]"></span>
                <span class="sw" [style.background]="currentSlide?.swatches?.[2]"></span>
              </div>
              <div class="ts-slide-name">{{ currentSlide?.name }}</div>
              <div class="ts-slide-meta">
                <span class="ts-slide-type">{{ currentSlide?.type }}</span>
                <span class="ts-slide-counter">
                  {{ slideshowIndex + 1 }} / {{ slideshowItems.length }}
                </span>
              </div>
            </div>
          </div>

          <div class="ts-slideshow-controls">
            <button
              mat-icon-button
              class="ts-slide-nav"
              [disabled]="slideshowItems.length < 2"
              (click)="prevSlide()"
              aria-label="Previous theme">
              <mat-icon>skip_previous</mat-icon>
            </button>

            <button
              mat-icon-button
              class="ts-slide-play"
              [disabled]="slideshowItems.length === 0"
              (click)="slideshowPlaying ? pauseSlideshow() : playSlideshow()"
              [attr.aria-label]="slideshowPlaying ? 'Pause' : 'Play'">
              <mat-icon>{{ slideshowPlaying ? 'pause' : 'play_arrow' }}</mat-icon>
            </button>

            <button
              mat-icon-button
              class="ts-slide-nav"
              [disabled]="slideshowItems.length < 2"
              (click)="nextSlide()"
              aria-label="Next theme">
              <mat-icon>skip_next</mat-icon>
            </button>

            <span class="ts-spacer"></span>

            <div class="ts-slideshow-speed">
              <label>Speed</label>
              <mat-form-field appearance="outline" class="ts-speed-select">
                <mat-select
                  [(ngModel)]="slideshowIntervalMs"
                  (selectionChange)="onSlideshowSpeedChange()">
                  <mat-option [value]="2000">Fast (2s)</mat-option>
                  <mat-option [value]="3000">Normal (3s)</mat-option>
                  <mat-option [value]="5000">Slow (5s)</mat-option>
                  <mat-option [value]="8000">Very slow (8s)</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
        </ng-container>

        <ng-template #noSlides>
          <p class="ts-hint">No themes available to preview yet.</p>
        </ng-template>
      </div>
    </mat-tab>

  </mat-tab-group>

  <!-- ─────────── SHARED PREVIEW PANE (commented out) ───────────
  <div class="ts-preview-wrap">
    <div class="ts-preview-label">
      <mat-icon>visibility</mat-icon>
      <span>Preview</span>
      <span class="ts-preview-name" *ngIf="previewThemeName">· {{ previewThemeName }}</span>
    </div>
    <div class="ts-preview" #previewPane>
      <div class="prev-toolbar">
        <span class="prev-logo"></span>
        <span class="prev-app-title">Dashboard</span>
        <span class="prev-spacer"></span>
        <span class="prev-user">User</span>
      </div>
      <div class="prev-body">
        <aside class="prev-sidebar">
          <div class="prev-nav-item active">Overview</div>
          <div class="prev-nav-item">Reports</div>
          <div class="prev-nav-item">Settings</div>
        </aside>
        <main class="prev-main">
          <div class="prev-card">
            <div class="prev-card-header">Sample Card</div>
            <div class="prev-card-body">
              <div class="prev-palette">
                <span *ngFor="let c of previewPalette" [style.background]="c"></span>
              </div>
              <div class="prev-card-text">The quick brown fox jumps over the lazy dog.</div>
              <button class="prev-btn" type="button">Primary Action</button>
            </div>
          </div>
        </main>
      </div>
    </div>
  </div>
  -->

  <!-- ─────────── SHARED FOOTER (TAB-AWARE) ─────────── -->
  <div class="ts-footer">
    <!-- Tab 0: Combined Theme + Layout Templates — Reset, Clear Layout, Apply -->
    <ng-container *ngIf="activeTabIndex === 0">
      <button mat-stroked-button color="warn" (click)="resetAll()">Reset to Default</button>
      <button
        mat-stroked-button
        color="warn"
        [disabled]="!activeLayoutId"
        (click)="clearLayout()">
        Clear Layout
      </button>
      <span class="ts-spacer"></span>
      <button
        mat-flat-button
        color="primary"
        [disabled]="!selectedId && !selectedLayoutId"
        (click)="applyCombinedPreview()">
        Apply &amp; Preview
      </button>
    </ng-container>

    <!-- Tab 1: Theme Templates (standalone) -->
    <ng-container *ngIf="activeTabIndex === 1">
      <button mat-stroked-button color="warn" (click)="resetAll()">Reset to Default</button>
      <span class="ts-spacer"></span>
      <button mat-flat-button color="primary" [disabled]="!selectedId" (click)="applyPreview()">
        Apply &amp; Preview
      </button>
    </ng-container>

    <!-- Tab 2: Custom Theme Builder -->
    <ng-container *ngIf="activeTabIndex === 2">
      <button mat-stroked-button color="warn" (click)="clearCustom()">Clear Custom</button>
      <span class="ts-spacer"></span>
      <button mat-flat-button color="primary" (click)="applyCustomPreview()">
        Apply &amp; Preview
      </button>
    </ng-container>

    <!-- Tab 3: Layout Templates (standalone) -->
    <ng-container *ngIf="activeTabIndex === 3">
      <button
        mat-stroked-button
        color="warn"
        [disabled]="!activeLayoutId"
        (click)="clearLayout()">
        Clear Layout
      </button>
      <span class="ts-spacer"></span>
      <button
        mat-flat-button
        color="primary"
        [disabled]="!selectedLayoutId"
        (click)="applyLayoutPreview()">
        Apply &amp; Preview
      </button>
    </ng-container>

    <!-- Tab 4: Slideshow -->
    <ng-container *ngIf="activeTabIndex === 4">
      <button mat-stroked-button (click)="cancelSlideshow()">Cancel</button>
      <span class="ts-spacer"></span>
    </ng-container>
  </div>
</div>
